export class Constants {
    /* ioBroker Socket */
    static IP: string = 'iobroker.drzewosz.de';
    static Port: number = 8084;
    static Protocol: string = 'https';
}
